<template>
  <div class="sn-f-b-s pathology-detail">
    <sn-navigator id="BGCX" :initial="perpetual.FUNCTION_ID_BLBG"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s pathology-detail-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_BLBG),
        replace: true,
        router: '/query/pathology',
      }, {
        title: `${$sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_BLBG)}详情`
      }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 detail-blank">
        <template v-if="!$sn.validate.empty(handleDetail)">
          <div class="sn-f-c-c detail-title">{{pathologyDetailInfo.category}}</div>
          <div class="sn-f-c-c detail-head">
            <div>姓名：{{pathologyDetailInfo.patient.patientName}}</div>
            <div class="sn-ph-10">检查时间：{{$sn.format.date(new Date(pathologyDetailInfo.checkTime), 'yyyy年MM月dd日')}}</div>
            <div>检查项目：{{pathologyDetailInfo.itemClass}}</div>
          </div>
          <div class="sn-table">
            <table>
              <thead>
                <tr>
                  <th>检查表现</th>
                  <th>检查诊断</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(detail, index) in handleDetail">
                  <td>{{detail.description}}</td>
                  <td>{{detail.impression}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="prompt-message">此报告数据仅作参考，以医院实际纸质报告为准。</div>
        </template>
        <template v-else>
          <sn-no-data></sn-no-data>
        </template>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';

export default {
  data() {
    return {
      perpetual: Constants,
      detailInfo: [],
      pathologyDetailInfo: {},
      isResult: true
    };
  },
  computed: {
    // 处理报告信息
    handleDetail() {
      let handle = [];
      if (this.detailInfo.length > 0) handle = this.detailInfo;
      return handle;
    }
  },
  watch: {},
  created: function() {
    document.title = `${this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_BLBG)}详情`;
    this.$route.meta.title = `${this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_BLBG)}详情`;
    this.pathologyDetailInfo = this.$sn.utils.getHospitalSessionStorage('Pathology_Info');
    this.getCheckDetail(this.pathologyDetailInfo);
  },
  methods: {
    // 报告详情
    getCheckDetail() {
      if (this.$sn.validate.empty(this.pathologyDetailInfo)) return false;
      if (this.$sn.validate.empty(this.pathologyDetailInfo.reqNo)) return false;
      const params = {
        url: this.$sn.format.caption(Swagger.getCheckInfo, [this.$sn.utils.getHospitalId()]),
        query: {
          hosId: this.$sn.utils.getHospitalId(),
          platformId: this.$sn.utils.getPlatformType(),
          platformUserId: this.$sn.utils.getOpenId(),
          reqNo: this.pathologyDetailInfo.reqNo,
          patName: encodeURIComponent(this.pathologyDetailInfo.patient.patientName),
          idCardNo: this.pathologyDetailInfo.patient.patientIdCardNo,
          cardNo: this.pathologyDetailInfo.cardNo,
          itemClass: this.pathologyDetailInfo.itemClass,
          type: 'BLBG'
        },
        header: true
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (result.data.length > 0) this.detailInfo = result.data;
          else this.detailInfo = [];
        }
        else this.$sn.assembly.toast({ caption: result?.msg || Messages.C001 });
      });
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.pathology-detail {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: $white;
  left: 0;
  top: 0;

  &-region {
    overflow: hidden;
    height: 100%;

    .detail-blank {
      overflow: hidden;
      width: 100%;
      height: 100%;
      padding: 20px 10% 0;
      display: flex;
      flex-direction: column;

      .detail-title {
        font-size: 20px;
        margin-bottom: 20px;
        font-weight: bold;
      }

      .detail-head {
        font-size: 16px;
        margin-bottom: 10px;
        border-bottom: 1px solid $border1;
        padding-bottom: 10px;
      }

      .sn-table {
        table {
          table-layout: fixed;
        }

        thead {
          background-color: $background1;

          th {
            color: $text1;
            border-right: 1px solid $white;
            border-radius: 0;

            &:last-child {
              border-right: 1px solid $border1;
            }
          }
        }

        th,
        td {
          @include fs(14);

          height: auto;
          min-height: 30px;
          color: $text1;
        }

        td {
          padding: 10px;
        }
      }

      .prompt-message {
        font-size: 16px;
        color: $red1;
        padding: 10px 0;
      }
    }
  }
}
</style>
